import { render } from "./Program.vue?vue&type=template&id=ba08fafa"
import script from "./Program.ts?vue&type=script&lang=js"
export * from "./Program.ts?vue&type=script&lang=js"

import "./Program.vue?vue&type=style&index=0&id=ba08fafa&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__